var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},[_c('b-img',{staticClass:"banner-image",attrs:{"src":require('@/assets/imgs/academy/banner.png'),"fluid":"","alt":"Banner image"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }